import { InputAdornment } from "@mui/material";
import { hasWritePermission } from "../../PermissionUtility";

export default function receiptsInvoicesFormInputs(values) {
  const canWriteUsers = hasWritePermission('invoice');

    return [
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gridColumnGap: "100px",
          mt: 3,
        },
        children: [         
          {
            shape: "input",
            type: "number",
            name: "transaction_fee",
            title: "Transaction Fee",
            label: "Transaction Fee (%)",
            className: "",
            placeholder: "Enter transaction fee percentage",
            width: '100%',
            inputProps: {
              step: "0.01",
              min: "0",
              max: "100",
               onKeyDown: (e) => {
      if (["e", "E", "+", "-"].includes(e.key)) {
        e.preventDefault();
      }
    }
            },
            validation: {
              required: true,
              requiredMessage: "Transaction Fee can't be empty",
              pattern: {
                value: /^(?:\d{1,2}(?:\.\d{1,2})?|100(?:\.00?)?)$/,
                message: "Please enter a valid percentage (0-100)"
              }
            },
            inputAdornments: {
              end: <InputAdornment position="end"> % </InputAdornment>,
            }
          },          
          {
            shape: "input",
            type: "number",
            name: "vat",
            title: "VAT",
            label: "VAT (%)",
            className: "",
            placeholder: "Enter VAT percentage",
            width: '100%',
            inputProps: {
              step: "0.01",
              min: "0",
              max: "100",
               onKeyDown: (e) => {
      if (["e", "E", "+", "-"].includes(e.key)) {
        e.preventDefault();
      }
    }
            },
            validation: {
              required: true,
              requiredMessage: "VAT can't be empty",
              pattern: {
                value: /^(?:\d{1,2}(?:\.\d{1,2})?|100(?:\.00?)?)$/,
                message: "Please enter a valid percentage (0-100)"
              }
            },
            inputAdornments: {
              end: <InputAdornment position="end"> % </InputAdornment>,
            }
          }
        ],
      },
      {
        shape: "div",
        type: "wrapper",
        className: "",
        sx: { 
          display: "flex", 
          justifyContent: "flex-start", 
          mt: 4 
        },
        children: [
          ...(canWriteUsers ? [{
            shape: "button",
            type: "action",
            title: values.mode === "view" ? "Edit" : "Update",
            submitButton: values.isupdate,
            name: "Add",
            sx: {
              px: 4,
            },
            validation: {
              hiddenRules: [
                {
                  mode: "view",
                },
              ],
            },
          }] : []),
        ],
      },
    ];
}